import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  ONLINE_STORE_OPEN_CONNECT_GOOGLE_EMAIL_MODAL,
  ONLINE_STORE_CLOSE_CONNECT_GOOGLE_EMAIL_MODAL,
} from 'actions/onlineStore/constants';

const showConnectEmailModal = createReducer(false, {
  [ONLINE_STORE_OPEN_CONNECT_GOOGLE_EMAIL_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_CONNECT_GOOGLE_EMAIL_MODAL]: () => false,
});

const connectEmailShop = createReducer(null, {
  [ONLINE_STORE_OPEN_CONNECT_GOOGLE_EMAIL_MODAL]: (draft, { payload }) =>
    payload.shop,
  [ONLINE_STORE_CLOSE_CONNECT_GOOGLE_EMAIL_MODAL]: () => null,
});

export default combineReducers({
  showConnectEmailModal,
  connectEmailShop,
});
